"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _DualFluidHeaderFixedContentLayout = _interopRequireDefault(require("../DualFluidHeaderFixContent/DualFluidHeaderFixedContentLayout"));
var _ComponentRowDual = _interopRequireDefault(require("../ComponentRow/ComponentRowDual7030"));
var _ComponentRowSingle = _interopRequireDefault(require("../ComponentRow/ComponentRowSingle"));
require("./DualHeaderDashboardLayout.css");
var _withAuthentication = _interopRequireDefault(require("../../hocs/withAuthentication"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutClasses = (0, _cssClassesHelper.getBEMClasses)('dual-header-dashboard-layout');
var DualHeaderDashboardLayout = function DualHeaderDashboardLayout(props) {
  return /*#__PURE__*/_react["default"].createElement(_DualFluidHeaderFixedContentLayout["default"], {
    headerSecondary: props.headerSecondary,
    footer: props.footer
  }, /*#__PURE__*/_react["default"].createElement(_ComponentRowSingle["default"], {
    customClass: "".concat(layoutClasses('notification-row')),
    component: props.notificationComponent
  }), /*#__PURE__*/_react["default"].createElement(_ComponentRowDual["default"], {
    customClass: layoutClasses('top-row'),
    component1: props.component1,
    component2: props.component2
  }), /*#__PURE__*/_react["default"].createElement(_ComponentRowSingle["default"], {
    customClass: "".concat(layoutClasses('bottom-row'), " container-with-shadow"),
    component: props.component3
  }));
};
var _default = exports["default"] = (0, _withAuthentication["default"])(DualHeaderDashboardLayout);